// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"7e4ffbb4","517":"d611071b","518":"d611071b","519":"062ce9d1","885":"6093e3a7","968":"d611071b"}[chunkId] + ".chunk.css";
};